import { render } from "./OtherDetailsEditPopUp.vue?vue&type=template&id=4237b9d8"
import script from "./OtherDetailsEditPopUp.vue?vue&type=script&lang=js"
export * from "./OtherDetailsEditPopUp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__